import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';

const AutoGiftsRulesRoute = (props) => {
	const basePath = props.path || '/autogiftsrules';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./List').then((res) => res.List), {
		basePath
	});
	const View = useLoadComponent(() => import('./EditAutoGiftRule').then((res) => res.viewAutoGiftRulePage), {
		basePath
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>

				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
};

AutoGiftsRulesRoute.propTypes = {
	path: PropTypes.string
};

export { AutoGiftsRulesRoute };
